import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';
import { useDispatch } from 'react-redux';

const fetcher = async (url) =>
  await AxiosConfig.create('put', url).call().getResponseData();

function useShortcuts(userId) {
  const dispatch = useDispatch();
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    `/shortcuts/${userId}`,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  if (error?.res?.status > 300) {
    const messageError = `Error ${error?.res?.status} - ${error?.res?.statusText} in useShortcut`;
    dispatch(
      setSnackBar({ open: true, message: messageError, color: 'error' })
    );
  }

  return {
    data: data?.data,
    isLoading: isLoading,
    isValidating: isValidating,
    mutate: mutate,
  };
}

export default useShortcuts;
